import { useApi } from '@hooks/useApi';
import { ApiError, ApiKeyType } from '@root/globalTypes';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { queryKeys } from '@utils/consts';
import { isError } from '@utils/apiHelpers';
import { ApiKeyData } from '@services/types';

export const useUpdateApiKey = ({
  id,
  acquirerId,
  callback,
}: {
  id: string;
  acquirerId: string;
  callback: () => void;
}) => {
  const { query } = useApi();
  const queryClient = useQueryClient();
  const [apiError, setApiError] = useState<ApiError | null>(null);

  const { mutate, isPending } = useMutation({
    mutationFn: (keyData: ApiKeyData): Promise<ApiKeyType | ApiError> => {
      return query({
        path: `v1/staff/acquirers/${acquirerId}/api_keys/${id}`,
        data: keyData,
        opt: {
          method: 'PUT',
        },
      });
    },
    onSettled: (data) => {
      if (!data) return;
      if (isError(data)) {
        setApiError(data);
      } else {
        callback();
      }
    },
    onSuccess: async () => {
      await queryClient.refetchQueries({ queryKey: [...queryKeys.acquirerApiKeys, acquirerId] });
    },
  });

  return {
    mutate,
    isPending,
    error: apiError,
  };
};
